'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportsAccessController = function () {
  function ReportsAccessController(entityService, loadingService, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ReportsAccessController);
    this.entityService = entityService;
    this.loadingService = loadingService;
    this.growl = growl;

    this.selectedLocationId = null;
    this.selectedPref = null;
    this.locations = [];

    this.initializeLocations();
  }

  (0, _createClass3.default)(ReportsAccessController, [{
    key: 'initializeLocations',
    value: function initializeLocations() {
      var _this = this;

      this.entityService.listAllLocations().then(function (response) {
        var firstItem = {
          entityId: null,
          name: '---- Select Location ----'
        };

        _this.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
      });
    }
  }, {
    key: 'loadAccess',
    value: function loadAccess() {
      var _this2 = this;

      if (!this.selectedLocationId) {
        return;
      }

      this.loadingService.showLoading('reportsAccess', 'Loading Reports Access ...');

      this.entityService.getEntityReportsAccess(this.selectedLocationId).then(function (response) {
        _this2.selectedReportsAccess = response.data;
      }).finally(function () {
        _this2.loadingService.hideLoading('reportsAccess');
      });
    }
  }, {
    key: 'toggleAccess',
    value: function toggleAccess(reportId) {
      var _this3 = this;

      if (!this.selectedLocationId) {
        return;
      }

      this.loadingService.showLoading('reportsAccess', 'Updating Reports Access ...');

      this.entityService.toggleEntityReportAccess(this.selectedLocationId, reportId).then(function (response) {
        _this3.growl.success('Report Access updated successfully', { ttl: 5000 });
      }).finally(function () {
        _this3.loadingService.hideLoading('reportsAccess');
      });
    }
  }]);
  return ReportsAccessController;
}();

exports.default = ReportsAccessController;


// WEBPACK FOOTER //
// ./client/app/components/admin/reportsAccess/reportsAccess.controller.js